import messages from './jobMessages';

const getLabelForJobEntity = (intl, jobType, isPlural) => {
  switch (jobType) {
    case 0:
    case 1:
    case 8:
    case 10:
    case 12:
    case 13:
    case 14:
    case 15:
    case 16:
    case 17:
    case 18:
    case 25:
    case 29:
    case 37:
    case 38:
    case 39:
    case 41:
    case 42:
    case 43:
    case 44:
    case 49:
    case 61:
      return isPlural
        ? intl.formatMessage(messages.Relations)
        : intl.formatMessage(messages.Relation);

    case 2:
    case 3:
    case 7:
    case 11:
    case 24:
    case 30:
    case 36:
    case 40:
      return isPlural ? intl.formatMessage(messages.Tasks) : intl.formatMessage(messages.Task);
    case 5:
      return isPlural
        ? intl.formatMessage(messages.Authorizations)
        : intl.formatMessage(messages.Authorization);
    case 4:
    case 6:
    case 26:
    case 33:
    case 66:
    case 67:
    case 68:
      return isPlural
        ? intl.formatMessage(messages.Registrations)
        : intl.formatMessage(messages.Registration);
    case 9:
    case 28:
    case 31:
    case 60:
    case 65:
    case 64:
      return isPlural
        ? intl.formatMessage(messages.Invoices)
        : intl.formatMessage(messages.Invoice);
    case 19:
    case 20:
    case 21:
    case 22:
    case 23:
    case 69:
      return isPlural
        ? intl.formatMessage(messages.Documents)
        : intl.formatMessage(messages.Document);
    case 27:
      return isPlural
        ? intl.formatMessage(messages.Transactions)
        : intl.formatMessage(messages.Transaction);
    case 32:
      return isPlural
        ? intl.formatMessage(messages.DraftInvoices)
        : intl.formatMessage(messages.DraftInvoice);

    case 34:
    case 35:
      return isPlural
        ? intl.formatMessage(messages.PlannedRegistrations)
        : intl.formatMessage(messages.PlannedRegistration);
    case 53:
      return isPlural
        ? intl.formatMessage(messages.Employees)
        : intl.formatMessage(messages.Employee);
    case 56:
      return isPlural
        ? intl.formatMessage(messages.PriceListItems)
        : intl.formatMessage(messages.PriceListItem);
    default:
      return '';
  }
};
export default getLabelForJobEntity;
